import {
  GetVenueByPlaceIdRequest,
  GetVenueByVenueIdRequest,
  NearestVenueRequest,
  NearestVenueResponse,
  VenueDataResponse,
} from 'src/common-services/types/venues-types'
import { BaseClient } from 'src/common-services/clients/base-client'

export class VenueClient extends BaseClient {
  getNearestVenues(request: NearestVenueRequest): Promise<NearestVenueResponse> {
    return this.call<NearestVenueResponse>('/venues/nearest', 'POST', {
      data: request,
    })
  }

  getVenueByVenueId(request: GetVenueByVenueIdRequest): Promise<VenueDataResponse> {
    return this.call<VenueDataResponse>(`/venues/venue-id/${encodeURI(request.venueId)}`, 'GET')
  }

  getVenuesByPlaceIds(request: GetVenueByPlaceIdRequest): Promise<VenueDataResponse[]> {
    return this.post<VenueDataResponse[]>(`/venues/by-place-id`, request)
  }
}
